// Browser polyfills injected by esbuild. The Unlink crypto/proof code references
// Node's `Buffer` and `process`; esbuild's `inject` replaces those free globals
// with these exports wherever they appear in the bundle.
import { Buffer as B } from 'buffer';
import P from 'process';
export const Buffer = B;
export const process = P;
if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = B;
if (typeof globalThis.process === 'undefined') globalThis.process = P;
